import initialState from "./initialState";
import { GET_SESSION_DETAILS_SUCCESS, ADD_SESSION_DETAILS_SUCCESS } from "../constants";

export default function sessionDetailsReducer(state = initialState.sessionDetails, action) {
  if (action.type == GET_SESSION_DETAILS_SUCCESS) return action.sessionDetails;
  if (action.type == ADD_SESSION_DETAILS_SUCCESS) return [...state, { ...action.sessionDetail }];
  return state;
}
